import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Parking } from '../../../../../projects/shared-lib/src/lib/models/parking';
import { PageSaleService } from '../../services/page-sale.service';
import { WebsiteSaleService } from '../../../../../projects/shared-lib/src/lib/services/website-sale.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { MessageObserverService } from '../../../../../projects/shared-lib/src/lib/services/message-observer.service';
import { PriceManagerService } from '../../services/price-manager.service';
import { PriceWeb } from '../../../../../projects/shared-lib/src/lib/models/price-web';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { TwDatePipePipe } from '../../../shared/pipe/tw-date-pipe.pipe';
import { TranslateLangPipe } from '../../../../../projects/shared-lib/src/lib/pipe/translate-lang.pipe';

@Component({
    selector: 'tw-page-venue-parking',
    templateUrl: './page-venue-parking.component.html',
    styleUrls: ['./page-venue-parking.component.css'],
    imports: [MatIcon, MatDivider, MatCheckbox, FormsModule, CurrencyPipe, TranslatePipe, TwDatePipePipe, TranslateLangPipe],
})
export class PageVenueParkingComponent implements OnInit {
    parking: Parking[] = [];
    @Input() eventsId: any[];
    @Input() showTitle = true;
    @Input() parkingData: Parking[] | null = null;
    @Input() isDialogMode = false;
    @Output() selectedParkingsChange = new EventEmitter<Parking[]>();
    dialogCheckState: { [id: number]: boolean } = {};

    constructor(
        private pageSaleService: PageSaleService,
        private websiteSaleService: WebsiteSaleService,
        public translate: TranslateService,
        private messageObserverService: MessageObserverService,
        private priceManagerService: PriceManagerService,
        private analyticsService: AnalyticsService,
    ) {}

    ngOnInit() {
        if (this.parkingData !== null) {
            this._initFromParkingData(this.parkingData);
            return;
        }
        this.doInit();
        this.priceManagerService.watchPriceSelection().subscribe(() => {
            const temp = this.priceManagerService.getPricesSelected();
            // console.log(temp)
            this.eventsId = temp.map((value1) => value1.eventId);
            if (this.eventsId && this.eventsId.length > 0) {
                this.getParking(0);
            } else {
                this.parking = [];
            }
        });
    }
    doInit() {
        const temp = this.priceManagerService.getPricesSelected();
        // console.log(temp)
        this.eventsId = temp.map((value1) => value1.eventId);
        if (this.eventsId && this.eventsId.length > 0) {
            this.getParking(0);
        } else {
            this.parking = [];
        }
    }

    getParking(qty) {
        this.pageSaleService.getParkingByListEvents(this.eventsId).subscribe((parking) => {
            this.parking = parking;
            this.parking.forEach((prk) => {
                prk.total = 0;
                prk.datesSelected = [];
                //  prk.date = new Date();
                prk.datesSelected[prk.date.toString()] = { bool: false };
                const temp = <PriceWeb>{
                    eventId: prk.eventId,
                    price: prk.amount,
                    parkingId: prk.id,
                    parkingDate: prk.date,
                    parkingType: prk.type,
                    qty: qty,
                };
                this.priceManagerService.addPriceParking(prk, prk.date, qty);
            });
        });
    }

    createHold() {
        this.parking.forEach((prk) => {
            prk.total = 0;
            Object.keys(prk.datesSelected).forEach((date) => {
                if (prk.datesSelected[date] && prk.datesSelected[date].bool) {
                    prk.total = prk.total + prk.amount;
                    this.priceManagerService.addPriceParking(prk, date, 1);
                } else {
                    this.priceManagerService.addPriceParking(prk, date, 0);
                }
            });
        });
        this.priceManagerService.getTotalForAllPrice();
    }

    private _initFromParkingData(parkings: Parking[]): void {
        this.parking = parkings;
        const autoSelect = parkings.length === 1;
        const state: { [id: number]: boolean } = {};
        parkings.forEach((p) => (state[p.id] = autoSelect));
        this.dialogCheckState = state;
        if (autoSelect) {
            this.selectedParkingsChange.emit([...parkings]);
        }
    }

    onDialogCheckChange(): void {
        const selected = this.parking.filter((prk) => this.dialogCheckState[prk.id]);
        this.selectedParkingsChange.emit(selected);
    }
}
